<template>
  <va-modal
    id="requestPriorityFormModal"
    ref="requestPriorityFormModal"
    :value="isOpen"
    size="medium"
    :noOutsideDismiss="true"
    :okText="$t('modals.buttons.save')"
    :cancelText="$t('modals.buttons.cancel')"
    @ok="updatePriority"
    @cancel="onCancel">

    <div slot="header" class="modal-title">
      <span>{{ $t('evocall.requests.actions.update_priority') }}</span>
    </div>

    <div class="evollu-form">
      <div class="row mb-5">
        <div class="col">
          <div>
            <label class="form-label">{{$t('people.inputs.select_priority')}}:</label>
            <multiselect
              v-model="form.priority"
              :options="priorities"
              track-by="id"
              label="name"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              :disabled="false"
              >
              <template slot="option" slot-scope="{option}">
                <span>
                  <i :class="[option.icon, option.class]" /> &nbsp;
                  {{ $t(`evocall.priorities.${option.id}`, option.name) }}
                  </span>
              </template>
              <template slot="singleLabel" slot-scope="{option}" class="d-flex align-items-center justify-content-center">
                <span>{{ $t(`evocall.priorities.${option.id}`, option.name) }}</span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
    </div>
  </va-modal>
</template>
<script>
import { RequestService } from '@/api/VirtualWaitingRoomService'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {
        priority: this.request.priority
      },
      priorities: [
        { id: 3, name: 'High', icon: 'fa fa-angle-up', class: 'priority priority--high' },
        { id: 2, name: 'Normal', icon: 'fa fa-minus', class: 'priority priority--normal' },
        { id: 1, name: 'Low', icon: 'fa fa-angle-down', class: 'priority priority--low' }
      ],
      isOpen: false
    }
  },
  mounted () {
    this.isOpen = true
  },
  methods: {
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('modal-closed')
      }, 500)
    },
    updatePriority: function () {
      RequestService.updatePriority(this.request.id, { priority_id: this.form.priority.id })
        .then(request => {
          this.showToast(this.$t('evocall.request.actions.priority_updated'), this.$store.state.successToastOptions)
          this.$emit('priority-updated', { request })
        })
        .catch(errors => {
          console.log(errors)
          this.showToast(this.$t('evocall.request.actions.priority_update_failed'), this.$store.state.errorToastOptions)
        })
        .finally(() => {
          this.onCancel()
        })
    }
  }
}
</script>

<style lang="scss">
$primary-red: #c42940;
$primary-yellow: #c49d29;
$primary-green: #29c4aa;
.multiselect {
  & .priority {
    &--low {
      font-size: 1.5rem;
      color: $primary-green;
      & span {
        font-size: 1rem;
        color: #a1a1a1;
      }
    }
    &--normal {
      font-size: 1rem;
      color: $primary-yellow;
      & span {
        font-size: 1rem;
        color: #a1a1a1;
      }
    }
    &--high {
      font-size: 1.5rem;
      color: $primary-red;
      & span {
        font-size: 1rem;
        color: #a1a1a1;
      }
    }
  }
}
</style>
